/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:39:17
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-10-11 09:01:22
 */
import configData from "../config/config";
import mumeListData from "./menu";
const systemConfigRole = () => import("../views/sys-manage/system-config/role/role.vue");
const systemConfigUser = () => import("../views/sys-manage/system-config/user/user.vue");
const systemConfigLog = () => import("../views/sys-manage/system-config/log/log.vue");
const systemConfigOnlineuser = () => import("../views/sys-manage/system-config/onlineuser/onlineuser.vue");
const systemConfigDictionary = () => import("../views/sys-manage/system-config/dictionary/dictionary.vue");
const systemConfigModelFile = () => import("../views/sys-manage/system-config/model-file/model-file.vue");
const systemConfigStopReason = () => import("../views/sys-manage/system-config/stop-reason/stop-reason.vue");
const systemConfigALarmSet = () => import("../views/sys-manage/system-config/alarm-set/alarm-set.vue");
const kafkaLog = () => import("../views/sys-manage/system-config/kafka-log/kafka-log.vue");
// const maintenanceEquipment = () =>
//   import("../views/sys-manage/maintenance/equipment/equipment.vue");
const maintenanceSIMCard = () => import("../views/sys-manage/maintenance/SIMCard/SIMCard.vue");
const systemMaintenanceAlarmOverview = () => import("../views/sys-manage/maintenance/alarm/alarmOverview/alarmOverview.vue");
const systemMaintenanceAlarmQuery = () => import("../views/sys-manage/maintenance/alarm/alarmQuery/alarmQuery.vue");
// const systemMaintenanceAlarmEvent = () =>
//   import("../views/sys-manage/maintenance/alarm/alarm-event/alarm-event.vue");
//
const projectconfigOper = () => import("../views/sys-manage/project-config/oper/oper.vue");
const alarmSetting = () => import("../views/sys-manage/project-config/alarmSetting/alarmSetting.vue");
const ratamanage = () => import("../views/sys-manage/project-config/ratemanage/ratemanage.vue");
const equipmentModel = () => import("../views/sys-manage/equipment-manage/equipment-model/equipment-model.vue");
const equipmentList = () => import("../views/sys-manage/equipment-manage/equipment-list/equipment-list.vue");
const auditHlhtSystem = () => import("../views/sys-manage/audit-hlht-system/audit-hlht-system.vue");
const systemNotice = () => import("../views/sys-manage/system-config/system-notice/system-notice.vue");
const producer = () => import("../views/sys-manage/equipment-manage/producer/producer.vue");
const collectionDataConfig = () => import("../views/sys-manage/collection-manage/data-config/data-config.vue");
const collectionChargingOperation = () => import("../views/sys-manage/collection-manage/charging-operation/charging-operation.vue");
const collectionOperData = () => import("../views/sys-manage/collection-manage/oper-data/oper-data.vue");
const productionCardClient = () => import("../views/sys-manage/production/card-client/card-client.vue");
const productionFactoryManage = () => import("../views/sys-manage/production/factory-manage/factory-manage.vue");
const simOutTest = () => import("../views/sys-manage/production/sim-out-test/sim-out-test.vue");
const simOutRecord = () => import("../views/sys-manage/production/sim-out-record/sim-out-record.vue");
const MessageManage = () => import("../views/sys-manage/message/message-manage/message-manage.vue");
const MessagePrice = () => import("../views/sys-manage/message/message-price/message-price.vue");
const MessageRecord = () => import("../views/sys-manage/message/message-record/message-record.vue");
const orderConfig = () => import("../views/sys-manage/system-config/order-config/order-config.vue");
const addValueService = () => import("../views/sys-manage/add-value-service/add-value-service.vue");
const productionOrder = () => import("../views/sys-manage/production/production-order/production-order.vue");
const salesOrder = () => import("../views/sys-manage/production/sales-order/sales-order.vue");
const operatorAccount = () => import("../views/sys-manage/operator/operator-account/operator-account.vue");
const operatorPostNotice = () => import("../views/sys-manage/operator/post-notice/post-notice.vue");
const menuList = () => import("../views/sys-manage/system-config/menu-list/menu-list.vue");
//productionFactoryManage
const allRouter = [
    {
        path: "/homepage/systemconfig/role",
        name: "权限管理",
        component: systemConfigRole,
    },
    {
        path: "/homepage/systemconfig/menu-list",
        name: "菜单",
        component: menuList,
    },
    {
        path: "/homepage/systemconfig/user",
        name: "用户管理",
        component: systemConfigUser,
    },
    {
        path: "/homepage/systemconfig/log",
        name: "日志管理",
        component: systemConfigLog,
    },
    {
        path: "/homepage/systemconfig/onlineuser",
        name: "在线用户",
        component: systemConfigOnlineuser,
    },
    {
        path: "/homepage/systemconfig/dictionary",
        name: "典表管理",
        component: systemConfigDictionary,
    },
    {
        path: "/homepage/systemconfig/model-file",
        name: "模板文件",
        component: systemConfigModelFile,
    },
    {
        path: "/homepage/systemconfig/stop-reason",
        name: "停止原因",
        component: systemConfigStopReason,
    },
    {
        path: "/homepage/systemconfig/alarm-set",
        name: "告警配置",
        component: systemConfigALarmSet,
    },
    {
        path: "/homepage/systemconfig/kafka-log",
        name: "Kafka日志",
        component: kafkaLog,
    },
    // {
    //   path: "/homepage/maintenance/equipment",
    //   name: "设备管理",
    //   component: maintenanceEquipment
    // },
    {
        path: "/homepage/maintenance/SIMCard",
        name: "SIM卡管理",
        component: maintenanceSIMCard,
    },
    {
        path: "/homepage/maintenance/alarm/summary",
        name: "告警概览",
        component: systemMaintenanceAlarmOverview,
    },
    {
        path: "/homepage/maintenance/alarm/query",
        name: "告警查询",
        component: systemMaintenanceAlarmQuery,
    },
    // {
    //   path: "/homepage/maintenance/alarm/event",
    //   name: "事件告警",
    //   component: systemMaintenanceAlarmEvent
    // },
    // {
    //   path: "/homepage/projectconfig/opr",
    //   name: "运营商列表",
    //   component: projectconfigOper
    // },
    // {
    //   path: "/homepage/homepage/projectconfig/opr",
    //   name: "运营商列表",
    //   component: projectconfigOper
    // },
    {
        path: "/homepage/projectconfig/alarmsetting",
        name: "告警配置",
        component: alarmSetting,
    },
    {
        path: "/homepage/projectconfig/ratamanage",
        name: "费率管理",
        component: ratamanage,
    },
    {
        path: "/homepage/projectconfig/site-tag",
        name: "站点标签管理",
        component: () => import("@/views/sys-manage/project-config/site-tag/site-tag.vue"),
    },
    {
        path: "/homepage/equipment-manage/equipment-model",
        name: "设备清单",
        component: equipmentModel,
    },
    {
        path: "/homepage/equipment-manage/equipment-list",
        name: "设备型号",
        component: equipmentList,
    },
    {
        path: "/homepage/equipment-manage/producer",
        name: "设备厂商",
        component: producer,
    },
    {
        path: "/homepage/equipment-manage/report-file",
        name: "档案报告",
        component: () => import("../views/sys-manage/equipment-manage/report-file/report-file.vue"),
    },
    {
        path: "/homepage/audit-hlht-system",
        name: "互联互通",
        component: auditHlhtSystem,
    },
    {
        path: "/homepage/operatormanage",
        name: "运营商管理",
        component: projectconfigOper,
    },
    {
        path: "/homepage/operator/account",
        name: "运营商对帐",
        component: operatorAccount,
    },
    {
        path: "/homepage/operator/post-notice",
        name: "发布通知",
        component: operatorPostNotice,
    },
    {
        path: "/homepage/operator/feedback",
        name: "运营商反馈",
        component: () => import("@/views/sys-manage/operator/feedback/feedback.vue"),
    },
    {
        path: "/homepage/systemconfig/system-notice",
        name: "系统公告",
        component: systemNotice,
    },
    {
        path: "/homepage/collection/data-config",
        name: "参数配置",
        component: collectionDataConfig,
    },
    {
        path: "/homepage/collection/charging-operation",
        name: "充电操作",
        component: collectionChargingOperation,
    },
    {
        path: "/homepage/collection/oper-data",
        name: "运维数据",
        component: collectionOperData,
    },
    {
        path: "/homepage/production/card-client",
        name: "充电卡客户端管理",
        component: productionCardClient,
    },
    {
        path: "/homepage/production/factory-manage",
        name: "出厂管理账号",
        component: productionFactoryManage,
    },
    {
        path: "/homepage/production/sim-out-test",
        name: "SIM卡出厂召测",
        component: simOutTest,
    },
    {
        path: "/homepage/production/sim-out-record",
        name: "SIM卡出厂记录",
        component: simOutRecord,
    },
    {
        path: "/homepage/message/manage",
        name: "短信管理",
        component: MessageManage,
    },
    {
        path: "/homepage/message/record",
        name: "短信定价",
        component: MessageRecord,
    },
    {
        path: "/homepage/message/config",
        name: "短信配置",
        component: () => import("@/views/sys-manage/message/message-config/message-config.vue"),
    },
    {
        path: "/homepage/message/price",
        name: "短信定价",
        component: MessagePrice,
    },
    {
        path: "/homepage/systemconfig/order-config",
        name: "订单校验配置",
        component: orderConfig,
    },
    {
        path: "/homepage/add-value-service",
        name: "增值服务管理",
        component: addValueService,
    },
    {
        path: "/homepage/production/production-order",
        name: "生产任务单",
        component: productionOrder,
    },
    {
        path: "/homepage/production/sales-order",
        name: "销售订单",
        component: salesOrder,
    },
    {
        path: "/homepage/systemconfig/site-size-config",
        name: "站点规模配置",
        component: () => import("@/views/sys-manage/system-config/site-size-config/site-size-config.vue"),
    },
    {
        path: "/homepage/we-chat/we-chat-release",
        name: "批量发布小程序",
        component: () => import("@/views/sys-manage/we-chat/we-chat-release/we-chat-release.vue"),
    },
    {
        path: "/homepage/we-chat/we-chat-template",
        name: "代码模板管理",
        component: () => import("@/views/sys-manage/we-chat/we-chat-template/we-chat-template.vue"),
    },
    {
        path: "/homepage/systemconfig/city-config",
        name: "省市区管理",
        component: () => import("@/views/sys-manage/system-config/city-config/city-config.vue"),
    },
    {
        path: "/homepage/systemconfig/service-provider",
        name: "服务商配置",
        component: () => import("@/views/sys-manage/system-config/service-provider/service-provider.vue"),
    },
    {
        path: "/homepage/sim-manage/operator-sim",
        name: "运营商SIM卡",
        component: () => import("@/views/sys-manage/sim-manage/operator-sim/operator-sim.vue"),
    },
    {
        path: "/homepage/sim-manage/system-sim",
        name: "后台SIM卡",
        component: () => import("@/views/sys-manage/sim-manage/system-sim/system-sim.vue"),
    },
    {
        path: "/homepage/sim-manage/change-record",
        name: "变更记录",
        component: () => import("@/views/sys-manage/sim-manage/sim-change-record/sim-change-record.vue"),
    },
    {
        path: "/homepage/sim-manage/renewal-record",
        name: "续费记录",
        component: () => import("@/views/sys-manage/sim-manage/sim-renewal-record/sim-renewal-record.vue"),
    },
    {
        path: "/homepage/operator/battery-test",
        name: "电池检测报告",
        component: () => import("@/views/sys-manage/operator/battery-test/battery-test.vue"),
    },
];
const getPower = (list) => {
    const prwerObj = {};
    const config = configData.powerObj;
    list.map((item) => {
        if (config[item.privilegeCode]) {
            prwerObj[config[item.privilegeCode]] = item.checked;
        }
    });
    return prwerObj;
};
const recursionRouter = (routerList, itemData) => {
    const userRouter = routerList.length == 0 ? mumeListData : routerList;
    const realRoutes = [];
    userRouter.forEach((v) => {
        allRouter.forEach((item) => {
            if (item.path != "" && item.path === v.url) {
                const data = JSON.parse(JSON.stringify(v));
                let privilegeVoObj = {};
                if (data.privilegeVoList && data.privilegeVoList.length > 0) {
                    privilegeVoObj = getPower(data.privilegeVoList);
                }
                if (item.meta) {
                    item.meta.menuData = data;
                    item.meta.privilegeVoObj = privilegeVoObj;
                }
                else {
                    item.meta = {
                        privilegeVoObj: privilegeVoObj,
                        menuData: data,
                    };
                }
                if (itemData) {
                    item.parentName = itemData.moduleName;
                }
                item.name = data.moduleName;
                if (privilegeVoObj.query) {
                    realRoutes.push(item);
                }
            }
        });
        if (v.children && v.children.length > 0) {
            const list = recursionRouter(v.children, v);
            list.forEach((li) => {
                realRoutes.push(li);
            });
        }
    });
    return realRoutes;
};
export default recursionRouter;
